<script>
import { getRequestSignHeader } from '@/utils/util'
import { saveUserFeedback } from '@/api'

function getBase64 (file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader()
    reader.readAsDataURL(file)
    reader.onload = () => resolve(reader.result)
    reader.onerror = error => reject(error)
  })
}
export default {
  name: 'Feedback',
  props: ['layerid'],
  data () {
    return {
      loading: false,
      fileList: [],
      previewVisible: false,
      previewImage: '',
      form: this.$form.createForm(this),
      headers: getRequestSignHeader('/api/user/image/upload')
    }
  },
  methods: {
    handleCancel () {
      this.previewVisible = false
    },
    async handlePreview (file) {
      if (!file.url && !file.preview) {
        file.preview = await getBase64(file.originFileObj)
      }
      this.previewImage = file.url || file.preview
      this.previewVisible = true
    },
    handleChange (e) {
       this.fileList = e.fileList
    },
    handleSubmit (e) {
      e.preventDefault()
      this.form.validateFields((err, values) => {
        if (!err) {
          const imgs = []
          for (let i = 0; i < this.fileList.length; i++) {
            imgs.push(this.fileList[i].response.data)
          }
          const params = {
            reply_email: values.email,
            type: values.type,
            title: values.title,
            content: values.content,
            imgs: imgs.join(',')
          }
          this.loading = true
          saveUserFeedback(params).then(res => {
            this.loading = false
            this.$confirm({
              title: this.$t('user.feedback.success'),
              content: this.$t('user.feedback.success.tip'),
              okText: this.$t('user.action.ok'),
              cancelText: this.$t('user.action.cancel'),
              onOk: () => {
                this.$layer.close(this.layerid)
              }
            })
          })
        }
      })
    }
  }
}
</script>

<template>
  <div style="width: 100%;padding: 8px;">
    <a-form :form="form" :label-col="{ span: 6 }" :wrapper-col="{ span: 17 }" @submit="handleSubmit">
      <a-form-item :label="$t('user.feedback.email')">
        <a-input
          :placeholder="$t('user.feedback.email.tip')"
          v-decorator="['email', { rules: [{ required: true, message: $t('user.feedback.email.tip') }] }]"
          allowClear></a-input>
      </a-form-item>
      <a-form-item :label="$t('user.feedback.type')">
        <a-select
          :placeholder="$t('user.feedback.type.tip')"
          v-decorator="['type', { rules: [{ required: true, message: $t('user.feedback.type.tip') }] }]">
          <a-select-option value="suggestion">{{ $t('user.feedback.type.suggestion') }}</a-select-option>
          <a-select-option value="bug">{{ $t('user.feedback.type.bug') }}</a-select-option>
          <a-select-option value="requirement">{{ $t('user.feedback.type.requirement') }}</a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item :label="$t('user.feedback.title')">
        <a-input
          :placeholder="$t('user.feedback.title.tip')"
          v-decorator="['title', { rules: [{ required: true, message: $t('user.feedback.title.tip') }] }]"
          :maxLength="120"></a-input>
      </a-form-item>
      <a-form-item :label="$t('user.feedback.content')">
        <a-textarea
          :placeholder="$t('user.feedback.content.tip')"
          style="height:180px;"
          v-decorator="['content', { rules: [{ required: true, message: $t('user.feedback.content.tip') }] }]"></a-textarea>
      </a-form-item>
      <a-form-item :label="$t('user.feedback.screenshots')">
        <div class="clearfix">
          <a-upload
            action="/api/user/image/upload"
            :headers="headers"
            list-type="picture-card"
            accept="image/*"
            :file-list="fileList"
            @preview="handlePreview"
            @change="handleChange"
          >
            <div v-if="fileList.length < 8">
              <a-icon type="plus" />
              <div class="ant-upload-text">
                {{ $t('user.action.pic.upload') }}
              </div>
            </div>
          </a-upload>
          <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
            <img alt="example" style="width: 100%" :src="previewImage" />
          </a-modal>
        </div>
      </a-form-item>
      <a-form-item :wrapper-col="{ offset: 6 }">
        <a-button type="primary" :loading="loading" html-type="submit">{{ $t('user.action.submit') }}</a-button>
      </a-form-item>
    </a-form>
  </div>
</template>

<style scoped>

</style>
